'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _filter2 = require('lodash/filter');

var _filter3 = _interopRequireDefault(_filter2);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

TrackAndTraceController.$inject = ['UrlParamService', 'WebApiService', '$scope'];


var _ = {
    find: _find3.default,
    filter: _filter3.default
};

var _module = _angular2.default.module('cb.ui-components.schade-melden.cb-track-and-trace', []);

_module.directive('cbTrackAndTrace', cbTrackAndTraceDirective);

exports.default = _module;


function cbTrackAndTraceDirective() {
    return {
        scope: true,
        controller: TrackAndTraceController,
        controllerAs: 'tt',
        link: function link(scope, element, attrs, ctrl) {}
    };
}

function TrackAndTraceController(UrlParamService, WebApiService, $scope) {
    var vm = this;

    var stappenplanCtrl = $scope.stappenplan;

    var requestData = {
        Claimnummer: UrlParamService.getUrlParam('CLAIM'),
        Subclaimnummer: UrlParamService.getUrlParam('SUBCLAIM'),
        Hashcode: UrlParamService.getUrlParam('HASH')
    };

    vm.step1disabled = true;
    vm.step2disabled = true;
    vm.step3disabled = true;
    vm.step4disabled = true;
    vm.step5disabled = true;

    vm.showLoading = true;
    vm.showError = false;

    WebApiService.get(requestData, 'OphalenClaimLight').then(function (result) {
        if (result.ok) {
            var claimsdata = {};

            /*
            Claims bestaan uit 5 stappen:
            - Schade gemeld
            - Schadehersteller
            - Uitkering schade
            - UItkering schade tegenpartij
            - Afronding
              Elke stap kan de status 1,2 of 3 hebben: niet gestart, gestart, afgerond
            */

            /* generiek */
            claimsdata.tekstsoort = 'overig';
            var soort = result.statusTrackEnTraceCollection.tt1.soortObject;
            if (soort == 'fiets') {
                claimsdata.tekstsoort = 'fiets';
            } else if (soort == 'brommer' || soort == 'scooter') {
                claimsdata.tekstsoort = 'bromfiets';
            }

            //Default status == 1 (niet gestart)
            claimsdata.stap1 = '1';
            claimsdata.stap2 = '1';
            claimsdata.stap3 = '1';
            claimsdata.stap4 = '1';
            claimsdata.stap5 = '1';

            /*  Data voor stap 1
            Informatie over de schade */
            claimsdata.stap1 = result.statusTrackEnTraceCollection.tt1.status;
            claimsdata.schadedatum = result.statusTrackEnTraceCollection.tt1.schadedatum;
            claimsdata.schadeGemeld = result.statusTrackEnTraceCollection.tt1.schadeGemeld;
            claimsdata.merk = result.statusTrackEnTraceCollection.tt1.merkOmschrijving;
            claimsdata.model = result.statusTrackEnTraceCollection.tt1.modelOmschrijving;
            claimsdata.soort = result.statusTrackEnTraceCollection.tt1.soortObject;
            claimsdata.schadeOmschrijving = result.statusTrackEnTraceCollection.tt1.omschrijvingSchade;
            claimsdata.naam = result.statusTrackEnTraceCollection.tt1.naamVerzekerde;
            claimsdata.schadenummer = result.statusTrackEnTraceCollection.tt1.claimnummer;

            // Stap 1 is altijd actief (status 2)
            if (claimsdata.stap1 == '1') {
                claimsdata.stap1 = '2';
            }

            /* Data voor stap 2, alle betrokkenen.  EV = Eigen Verzekerde, TP = Tegenpartij */
            var ev = _.find(result.statusTrackEnTraceCollection.tt2, function (v) {
                return v.soortRelatie === 'EV';
            });
            var tp = _.find(result.statusTrackEnTraceCollection.tt2, function (v) {
                return v.soortRelatie === 'TP';
            });

            claimsdata.typeSchade = 'allrisk';
            if (!ev || ev.length === 0) {
                claimsdata.typeSchade = 'wa';
            }

            if (claimsdata.typeSchade == 'wa') {
                if (!tp) {
                    vm.showError = true;
                    return;
                }

                _angular2.default.forEach(tp, function (val) {
                    if (claimsdata.stap2 == '1' && val.status == 2) {
                        claimsdata.stap2 = '2';
                    }
                    if (val.status == 3) {
                        claimsdata.stap2 = '3';
                    }
                });
            } else {
                claimsdata.stap2 = ev.status;
                claimsdata.oplossingscode = ev.oplossingCode;
                claimsdata.hersteloptie = ev.oplossingCode;
                claimsdata.herstellerNaam = ev.naam;
                claimsdata.herstellerStraat = ev.straatOpgemaakt;
                claimsdata.herstellerPlaats = ev.plaatsOpgemaakt;
                claimsdata.herstellerTelefoon = ev.telefoonnummer;
                claimsdata.herstelStatus = ev.status;
            }

            /*  Data voor stap 3
            EV is eigen verzekerde, TP is tegenpartij */
            ev = _.find(result.statusTrackEnTraceCollection.tt3, function (v) {
                return v.soortRelatie === 'EV';
            });

            tp = _.filter(result.statusTrackEnTraceCollection.tt3, function (v) {
                return v.soortRelatie === 'TP';
            });

            /*  Als er geen EV is dan de status van TP pakken
            Als EV nog op 1 staat is dat de status.
            */
            claimsdata.stap3 = ev ? ev.status : tp ? tp[0].status : 1;
            claimsdata.betalingen = [];
            claimsdata.evAfgehandeld = true;

            if (ev) {
                _angular2.default.forEach(ev.tt3Betalingen, function (val) {
                    claimsdata.betalingen.push({
                        naam: val.naamBegunstigde,
                        datum: val.datumBetaling,
                        bedrag: '€ ' + val.bedragUitbetaling.toString().replace('.', ',')
                    });
                });
                if (ev.status == '2') {
                    claimsdata.evAfgehandeld = false;
                }
            }

            claimsdata.tpAantal = tp ? tp.length : 0;
            claimsdata.tpAfgehandeld;

            if (claimsdata.tpAantal > 0) {
                claimsdata.tpAfgehandeld = true;
                _angular2.default.forEach(tp, function (val) {
                    if (val.status == 1) {
                        claimsdata.tpAfgehandeld = false;
                    }
                    if (val.status == 2) {
                        claimsdata.tpAfgehandeld = false;

                        if (claimsdata.stap3 === '1') claimsdata.stap3 = '2';
                    }
                    if (val.status == 3 && claimsdata.stap3 == '1') {
                        claimsdata.stap3 = '2';
                    }
                });
            }

            claimsdata.stap4 = result.statusTrackEnTraceCollection.tt4.status;
            claimsdata.stap5 = result.statusTrackEnTraceCollection.tt5.status;

            var lastdone = 0;
            vm.activeStep = '0';

            switch (claimsdata.stap1) {
                case '1':
                    vm.step1disabled = true;
                    break;
                case '2':
                    vm.step1disabled = false;
                    vm.activeStep = '1';
                    stappenplanCtrl.openStep(1);
                    break;
                case '3':
                    vm.step1disabled = false;
                    vm.step1done = true;
                    lastdone = 1;
                    break;
                default:
                    vm.step1disabled = false;
                    vm.step1done = false;
                    break;
            }

            switch (claimsdata.stap2) {
                case '1':
                    vm.step2disabled = true;
                    break;
                case '2':
                    vm.step2disabled = false;
                    vm.activeStep = '2';
                    stappenplanCtrl.openStep(2);
                    break;
                case '3':
                    vm.step2disabled = false;
                    vm.step2done = true;
                    lastdone = 2;
                    break;
                default:
                    vm.step2disabled = false;
                    vm.step2done = false;
                    break;
            }

            switch (claimsdata.stap3) {
                case '1':
                    vm.step3disabled = true;
                    break;
                case '2':
                    vm.step3disabled = false;
                    vm.activeStep = '3';
                    stappenplanCtrl.openStep(3);
                    break;
                case '3':
                    vm.step3disabled = false;
                    vm.step3done = true;
                    lastdone = 3;
                    break;
                default:
                    vm.step3disabled = false;
                    vm.step3done = false;
                    break;
            }

            switch (claimsdata.stap4) {
                case '1':
                    vm.step4disabled = true;
                    break;
                case '2':
                    vm.step4disabled = false;
                    vm.activeStep = '4';
                    stappenplanCtrl.openStep(4);
                    break;
                case '3':
                    vm.step4disabled = false;
                    vm.step4done = true;
                    lastdone = 4;
                    break;
                default:
                    vm.step4disabled = false;
                    vm.step5done = false;
                    break;
            }

            switch (claimsdata.stap5) {
                case '1':
                    vm.step5disabled = true;
                    break;
                case '2':
                    vm.step5disabled = false;
                    vm.activeStep = '5';
                    stappenplanCtrl.openStep(5);
                    break;
                case '3':
                    vm.step5disabled = false;
                    vm.step5done = true;
                    lastdone = 5;
                    break;
                default:
                    vm.step5disabled = false;
                    vm.step5done = false;
                    break;
            }

            if (vm.activeStep == 0 && lastdone !== 0) {
                stappenplanCtrl.openStep(lastdone);
            }

            vm.claimsdata = claimsdata;
        }
        vm.showLoading = false;
    }, function (error) {
        vm.showError = true;
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/track-and-trace/cb-track-and-trace.directive.js
// module id = 921
// module chunks = 0